<template>  
  <div>    
  <b-modal
    id="view-fire-alarm-modal"
    title="Fire Alarm View Modal"
    centered
    hide-footer
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
    
  >
    <template #modal-title>
      <h2 class="m-0">{{ alarm_type === 'false_alarm' ? 'False Alarms':'Fire Alarms'  }}</h2>
    </template>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="fire_alarms"
      details-td-class="m-1 p-1"
      small
      v-if="hasPermission('read_fire_alarm')"
      :per-page="0"
    >
      

      <template #cell(site_data)="row">
        {{
          row.item.site_data ? row.item.site_data.name : ""
        }}
      </template>

      <template #cell(building_data)="row">
        {{
          row.item.building_data ? row.item.building_data.name : ""
        }}
      </template>

      <template #cell(address)="row">
        {{
          row.item.building_data ? row.item.building_data.address : ""
        }}
      </template>

      <template #cell(device_data)="row">
        {{
          row.item.building_data ? row.item.building_data.ase_number : ""
        }}
      </template>

      <template #cell(manage)="row">
        <b-button
          variant="success"
          pill
          size="sm"
          class="mr-50"
          @click="falseAlarm(row.item)"
          v-if="hasPermission('update_fire_alarm')"
          :disabled="row.item.is_false === true ? true:false"
        >
          False Alarm
        </b-button>

        <b-button
          variant="success"
          pill
          size="sm"
          class="mr-50"
          @click="deactivateAlarm(row.item)"
          v-if="hasPermission('update_fire_alarm')"
          :disabled="row.item.status === true ? false:true"
        >
          Deactivate Alarm
        </b-button>
      </template>
    </b-table>
    <div class="row">
        <div class="col-md-9">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-3">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
  </b-modal>  
  </div>  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: { alarm_type: String },
  mixins: [util],
  data() {
    return {
      required,
      fields: [
        { key: "site_data", label: "Site" },
        { key: "building_data", label: "Building" },
        { key: "device_data", label: "ASE #" },
        { key: "address", label: "Building Address" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      fire_alarms: [],
      fire_alarm: {},
    };
  },
  methods: {
    ...mapActions({
      getFireAlarms: "appData/getFireAlarms",
    }),
    async fetchPaginatedData() {
      console.log("alarm_type", this.alarm_type);
      try {
        const res = await this.getFireAlarms({
          pageNumber: this.currentPage,
          alarm_type: this.alarm_type,
        });
        this.fire_alarms = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalShow(){
      await this.fetchPaginatedData();
    },

  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
  
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission"
    }),
  },
};
</script>

<style></style>
